import { MAX_STARS } from "@versedrill/core";
import { cn } from "@/lib/utils";

export function StarRow({
  count,
  size = "text-4xl",
  animate = false,
  thresholds,
  className,
}: {
  count: number;
  size?: string;
  animate?: boolean;
  /** Points needed for each star (0 for the first). Shown under the stars so players see what the next one takes. */
  thresholds?: readonly number[];
  className?: string;
}) {
  return (
    <div className={cn("flex items-start gap-1", className)} role="img" aria-label={`${count} out of ${MAX_STARS} stars`}>
      {Array.from({ length: MAX_STARS }, (_, i) => (
        <div key={i} className="flex min-w-[1.2em] flex-col items-center gap-1">
          <span
            aria-hidden
            className={cn(
              "font-display leading-none",
              size,
              i < count ? "text-hint drop-shadow-[0_1px_0_color-mix(in_oklch,var(--hint)_50%,black)]" : "text-border",
              animate && i < count && "animate-ink-in",
            )}
            style={animate ? { ["--d" as string]: `${i * 140 + 200}ms` } : undefined}
          >
            {i < count ? "★" : "☆"}
          </span>
          {thresholds && (
            <span aria-hidden className={cn("font-ui text-xs tabular-nums", i < count ? "font-semibold text-foreground" : "text-muted-foreground")}>
              {thresholds[i]}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
